import React from "react";
import PropTypes from "prop-types";

import translate from "../../translations";
import UserDetailsForm from "./user-details-form";

export default function UserDetailsPage(props) {
  const tool = props.tool;

  if (window.parent) {
    window.parent.postMessage(
      {
        ga4_event: "page_view",
        eventData: {
          page_location: "#submit",
        },
      },
      "*"
    );
  }

  return (
    <div>
      <div className="user-details-header">
        <h4 className="text-primary">
          {translate("TextSelfAssessmentReport")}
        </h4>
        <p>
          <span>{translate("UserDetailsPrompt")}</span>{" "}
          <span>
            {tool.name} {translate("TextSelfAssessmentReport")}
          </span>
        </p>
      </div>
      <div>
        <div className="user-details-form-container">
          <UserDetailsForm
            countryList={props.countryList}
            country={props.country}
            source={props.source}
            onSubmit={(values) => props.onSubmit(values)}
          ></UserDetailsForm>
        </div>
      </div>
    </div>
  );
}

UserDetailsPage.propTypes = {
  onSubmit: PropTypes.func,
  tool: PropTypes.object,
  country: PropTypes.string,
  source: PropTypes.string,
  countryList: PropTypes.array,
};
